@if (masterSite) {
    <div>
        <span class="title">Master Site:</span>
        <button class="ace-btn btn-link ws-no-margin ws-no-padding editable"
                [disabled]="isDisabled"
                (click)="navigateToSite(masterSite.siteId)"
                title="View {{ getLinkedSiteName(masterSite) }}">
            {{ getLinkedSiteName(masterSite) }}
        </button>
    </div>
}
@if ((!masterSite) && linkedSites && linkedSites.length) {
    <div>
        <span class="title">Linked To:</span>
        <button class="ace-btn btn-link ws-no-margin ws-no-padding editable"
                [disabled]="isDisabled"
                (click)="showLinkedSites()"
                title="View linked sites">
            {{ linkedSites.length|number }} Site{{ linkedSites.length > 1 ? 's' : '' }}
        </button>
    </div>
}
